import { Box } from '@mui/material';
import type { FieldMode } from '../../../hooks/useCaseField';
import StatusChip from './StatusChip';
import OverrideReasonChip from './OverrideReasonChip';
import { CaseDateDisplay } from '../../fields';
import AuditTimeline from './AuditTimeline';

interface StatusSectionProps {
  mode: FieldMode;
}

const StatusSection: React.FC<StatusSectionProps> = ({ mode }) => (
  <Box sx={{ mb: 2.5 }}>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
      <StatusChip mode={mode} />
      <OverrideReasonChip mode={mode} />
    </Box>
    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 1.5, mb: 2 }}>
      <CaseDateDisplay mode={mode} label="Created" getValue={d => d.createdAt} />
      <CaseDateDisplay mode={mode} label="Submitted" getValue={d => d.submittedAt} />
    </Box>
    <AuditTimeline mode={mode} />
  </Box>
);

export default StatusSection;